export const GET_ACCOUNTING_ACCOUNTS = 'GET_ACCOUNTING_ACCOUNTS_CLIENTS';
export const GET_ACCOUNTING_ACCOUNTS_SUCCESS = 'GET_ACCOUNTING_ACCOUNTS_SUCCESS';
export const GET_ACCOUNTING_ACCOUNTS_FAIL = 'GET_ACCOUNTING_ACCOUNTS_CLIENTS_FAIL';